// extracted by mini-css-extract-plugin
export default {"wrapper":"LinkWithIcon_wrapper__LeeSV","label":"LinkWithIcon_label__j-tsc"};